import React from "react";

function CreatSelectElements(props) {
  const [bodyPartList, setBodyPartListElements] = React.useState([]);
  const [targetList, setTargetList] = React.useState([]);
  const dropDownLists = {
    back: ["lats", "spine", "upper back", "traps"],
    cardio: ["cardiovascular system"],
    chest: ["pectorals", "serratus anterior"],
    "lower arms": ["forearms"],
    "lower legs": ["calves"],
    neck: ["levator scapulae"],
    shoulders: ["delts"],
    "upper arms": ["biceps", "triceps"],
    "upper legs": ["glutes", "quads", "hamstrings", "abductors", "adductors"],
    waist: ["abs"],
  };

  if (bodyPartList.length === 0) {
    setBodyPartListElements(Object.keys(dropDownLists));
  }
  function handelSelectedList(e) {
    setTargetList(dropDownLists[e.target.value]);
    props.handleSelectBodyPart(e.target.value);
    props.updateMuscleTarget("");
  }
  function handelSelectMuscleTarget(e) {
    // condition to prevent from updating the muscle target state with the default option.
    if (e.target.value !== e.target.childNodes[0].value) {
      props.updateMuscleTarget(e.target.value);
      props.handleSelectBodyPart(undefined);
    }
  }

  return (
    <>
      <select
        className="cursor-pointer border-2 m-2 p-2"
        onChange={handelSelectedList}
      >
        <option value="" defaultValue={null}>
          --Select Your Body part--
        </option>
        {bodyPartList.map((bodyPart) => (
          <option value={bodyPart} key={bodyPartList.indexOf(bodyPart)}>
            {bodyPart}
          </option>
        ))}
      </select>
      <select
        className="cursor-pointer border-2 m-2 p-2"
        onChange={handelSelectMuscleTarget}
        value={props.muscleTarget}
      >
        <option value={undefined}>--Select Your Muscle Target--</option>
        {targetList.map((element) => (
          <option value={element} key={targetList.indexOf(element)}>
            {element}
          </option>
        ))}
      </select>
    </>
  );
}
export default CreatSelectElements;
